import { createContext } from "react";

export const EstimateStructureContext = createContext(null);